module.exports = __webpack_public_path__ + "static/media/hamburger.52a43632.svg";